import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadTelemetryListAllBegin, loadTelemetryListAllFailed, loadTelemetryListAllSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_MDS_URL } from '../../../configs';

export default function* loadTelemetryListAll(action) {
  try {
    const pool = {};
    const url = `${BACKEND_MDS_URL}/agency/vehicles/telemetry`;
    yield put(loadTelemetryListAllBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield getBodyJson(dataResponse);
    if (dataResponse.status === OK && data?.data) {
      yield put(loadTelemetryListAllSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadTelemetryListAllFailed());
      yield call(rejectActionPromise(action, data.data));
    }
  } catch (e) {
    yield put(loadTelemetryListAllFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
